import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { SESSION_STORAGE_KEYS } from '../../constants';
import { BrandingService } from '../services/user/branding.service';
import { environment } from '../../../environments/environment';
import { hasPendingDeepLink } from '../services/pending-deep-link';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ErrorComponent implements OnInit {
  logoPath: string = null as any;

  constructor(private brandingService: BrandingService) {}


  errorMessage: string = "You are not authorized to view this page. Please login in via the correct link";
  /** A signed-out external user opened an AWI link (ARAP-1911): they sign in through Control Center and come back to it. */
  waitingForSignIn = false;
  controlCenterUrl: string = environment.controlCenterLoginURL || '';

  ngOnInit(): void {
    this.brandingService.getLogoPath().subscribe({
      next: (logo: string) => this.logoPath = logo,
      error: () => this.logoPath = './assets/alight_worklife_logo_black.svg'
    });

    if (sessionStorage.getItem(SESSION_STORAGE_KEYS.SAML_ERROR)) {
      this.errorMessage = "Not authorized. You dont have the required permissions. Check if you have access to crp-admin-content.";
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.SAML_ERROR);
    } else if (!sessionStorage.getItem('token') && !sessionStorage.getItem('id_token') && hasPendingDeepLink()) {
      this.waitingForSignIn = true;
      this.errorMessage = "To open this page, sign in through Control Center. You'll come straight back to it after you sign in.";
    }
  }
}
